package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * App-side display typography: JetBrains Mono at large sizes. Reserved for
 * "moments of precision" — onboarding headlines, the home greeting, the
 * completion screen, standup detail date. Not for general page titles
 * (use [AppPageHeader] for those).
 */
enum class DisplaySize(val className: String) {
    Sm("sb-display-sm"),
    Md("sb-display-md"),
    Lg("sb-display-lg"),
}

@Composable
fun DisplayHeadline(
    text: String,
    size: DisplaySize = DisplaySize.Md,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = text,
        modifier = Modifier
            .classNames(size.className)
            .color(Palette.textPrimary)
            .then(modifier),
    )
}
